/**
 * Desktop styles
 * Styles specific to desktop devices
 */

/**
 * Desktop-specific styles for BrandsCarousel.
 */

export const desktopContainerStyles = {
  padding: 3, // Equivalent to theme.spacing(3)
  width: '100%',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export const desktopTitleStyles = {
  fontSize: '2rem',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '32px',
  color: '#0A3954',
  width: '100%'
};

export const desktopCarouselContainerStyles = {
  '.slick-track': {
    gap: '16px',
  },
  '.slick-slide': {
    margin: '0 16px',
  },
  '.slick-list': {
    margin: '0 -16px',
    overflow: 'visible',
    paddingLeft: 'auto', // Center alignment adjustments
    paddingRight: 'auto',
  },
  overflowX: 'visible',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: 'fit-content',
  // Media queries previously inside carouselContainerStyles for desktop ranges
  '@media (min-width: 1000px) and (max-width: 1024px)': {
    '.slick-track': {
      gap: '14px',
    },
  },
  // Add other desktop media queries if needed
};

export const desktopBrandCardStyles = {
  borderRadius: '16px',
  border: 'none',
  height: '150px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  width: '150px',
  flex: '0 0 150px',
  marginLeft: 0,
  '&:first-of-type': {
    marginLeft: 0,
  },
};

export const desktopBrandImageContainerStyles = {
  padding: '20px',
  height: '65%',
};

export const desktopBrandNameStyles = {
  padding: '15px',
  height: '35%',
};

export const desktopBrandTypographyStyles = {
  fontSize: '1rem',
  width: '100%',
  textAlign: 'center',
  lineHeight: 1.5,
};

// Desktop alternative styles
export const desktopAlternativeBrandCardStyles = {
  ...desktopBrandCardStyles,
  // Desktop specific overrides for alternative layout
};

export const desktopAlternativeBrandImageContainerStyles = {
  ...desktopBrandImageContainerStyles,
  // Desktop specific overrides for alternative layout
};

export const desktopAlternativeBrandNameStyles = {
  ...desktopBrandNameStyles,
  // Desktop specific overrides for alternative layout
};

export const desktopAlternativeBrandTypographyStyles = {
  ...desktopBrandTypographyStyles,
  // Desktop specific overrides for alternative layout
};

// Style moved from DesktopCarousel.js
export const desktopCarouselWrapperStyles = {
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'auto',
  gap: '24px',
  padding: '24px 0',
  scrollbarWidth: 'none', // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Chrome, Safari, Edge
  }
}; 